import { useDeliveryTemplates } from '@/hooks/useDeliveryTemplates';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DeleteAddressDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  address: any | null;
}

export const DeleteAddressDialog = ({
  open,
  onOpenChange,
  address,
}: DeleteAddressDialogProps) => {
  const { deactivateTemplate } = useDeliveryTemplates();

  const handleDelete = async () => {
    if (!address) return;

    try {
      await deactivateTemplate(address.id);
      onOpenChange(false);
    } catch (error) {
      // Error handled by hook
    }
  };

  const usageCount = address?.usage_count || 0;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Deactivate Address</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Are you sure you want to deactivate "{address?.location_name}"?
            </p>
            {usageCount > 0 && (
              <p className="font-semibold text-foreground">
                This address is used in {usageCount} job{usageCount !== 1 ? 's' : ''}.
              </p>
            )}
            <p>
              This action will deactivate the address. It won't appear in your library, but
              historical data for jobs using this address will be preserved.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} className="bg-destructive hover:bg-destructive/90">
            Deactivate
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
